// Coordinates the two ways the Twin chat can appear so they never double-render: the
// app-wide TwinChatWidget (config toggle) and the per-screen TwinChatLive element.
// When a screen explicitly drops the chat element, it "claims" the page and the
// global widget stands down — the page-specific instance takes precedence.

type PageChatListener = () => void;

let pageChatCount: number = 0;
const listeners: Set<PageChatListener> = new Set<PageChatListener>();

function notify(): void {
  for (const listener of listeners) {
    listener();
  }
}

// Called by a per-screen TwinChatLive element when it mounts at runtime; returns an
// unregister fn to call on unmount. Tied to the element's presence (not its mount
// success), so a dropped chat element always takes precedence over the global one.
export function registerPageChat(): () => void {
  pageChatCount += 1;
  notify();
  let released: boolean = false;
  return (): void => {
    if (released) {
      return;
    }
    released = true;
    pageChatCount = Math.max(0, pageChatCount - 1);
    notify();
  };
}

// True while at least one per-screen chat element is mounted — the global widget
// suppresses itself in that case.
export function isPageChatActive(): boolean {
  return pageChatCount > 0;
}

// Subscribe to page-chat presence changes; returns an unsubscribe fn.
export function subscribePageChat(listener: PageChatListener): () => void {
  listeners.add(listener);
  return (): void => {
    listeners.delete(listener);
  };
}
